import { useUserStore } from '@/pinia/user'
import storage from '@/utils/storage'

export const searchUrl = ref(storage.get('searchUrl'))

export const useSearchUrl = () => {
  const init = () => {
    const token = useUserStore().userInfo.tk
    if (token) {
      searchUrl.value = null
      storage.remove('searchUrl')
      return
    }
    const { search = '' } = window.location
    if (search && search.includes('source=')) {
      const _search = search.replace('&tpage=not', '')
      searchUrl.value = _search
      storage.set('searchUrl', _search)
    }
  }

  const source = computed(() => {
    if (searchUrl.value == null) return null
    return new URLSearchParams(searchUrl.value).get('source')
  })

  return {
    searchUrl,
    source,
    init
  }
}
